import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { logger } from 'src/lib/logger'
import { queries } from 'src/lib/query-keys'

interface CreateSneakChannelResponse {
  message: string
  cid: string
}

const createSneakChannel = async (recipientId: string) => {
  try {
    const response = await postRequest<CreateSneakChannelResponse>(`/chats/sneak?recipient_id=${recipientId}`)
    if (!response?.cid) {
      throw new Error('No cid returned from createSneakChannel')
    }
    const parts = response.cid.split(':')
    const chatId = parts[1]
    return chatId
  } catch (error) {
    logger.error('💥 Error creating sneak channel:', error)
    throw error
  }
}

export const useCreateSneakChannel = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createSneakChannel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.users.me.queryKey })
    },
  })
}
